function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/ems/mend/${viewName}`)
            modules.default.options.metaInfo = { title }
            resolve(modules)
        }, reject, 'plan')
    }
}

let routes = [
    {
        name: 'mendList',
        path: '/ems/mendList',
        meta: {
            title: '故障列表'
        }
    },
    {
        name: 'mendDetail',
        path: '/ems/mendDetail',
        meta: {
            title: '故障详情'
        }
    },
    {
        name: 'mendItemDetail',
        path: '/ems/mendItemDetail',
        meta: {
            title: '报修单详情'
        }
    },
    {
        name: 'mendEditor',
        path: '/ems/mendEditor',
        meta: {
            title: '报修单'
        }
    },
    {
        name: 'mendLog',
        path: '/ems/mendLog',
        meta: {
            title: '报修记录'
        }
    },
    {
        name: 'mendRegister',
        path: '/ems/mendRegister',
        meta: {
            title: '维修登记'
        }
    },
    {
        name: 'mendAccept',
        path: '/ems/mendAccept',
        meta: {
            title: '验收登记'
        }
    }
]

routes.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/modules/ems/mend.js